import React, { createContext, useEffect, useState } from 'react';
import {createUserWithEmailAndPassword, getAuth, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, signOut, updateProfile} from 'firebase/auth'
import app from '../firebase/firebase.config';


export const AuthContext = createContext()
const auth = getAuth(app)

const AuthProvider = ({children}) => {
    const [user, setUser] =useState(null)
    const [loading,setLoading]= useState(true)


    const createUser=(email,password)=>{
        setLoading(true)
        return createUserWithEmailAndPassword(auth,email, password)
    }
    const signIn=(email,password)=>{
        setLoading(true)
        return signInWithEmailAndPassword(auth, email, password)
    }
    const updateUser =(profile)=>{
        setLoading(true)
        return updateProfile(auth.currentUser,profile)
    }
    const googleSingPop=(provider)=>{
        setLoading(true)
        return signInWithPopup(auth, provider)
    }
    const logOut=()=>{
        setLoading(true)
        return signOut(auth)
    }

    useEffect(()=>{
        const unsubscribe = onAuthStateChanged(auth, currentUser=>{
             console.log(currentUser);
             setUser(currentUser)
             setLoading(false)
         })
         return ()=>{
             return unsubscribe();
         }
     },[])




    const authInfo = {
        user,
        loading,
        createUser,
        signIn,
        updateUser,
        googleSingPop,
        logOut
    }


    return (
        <div>
            <AuthContext.Provider value={authInfo}>
                {children}
            </AuthContext.Provider>
            
        </div>
    );
};

export default AuthProvider;